import React from 'react';

// Alphabetical order please

import Add from './add';
import AddReview from './addReview';
import AfterPayArrows from './afterpay-arrows';
import AfterPayLogo from './afterpay-logo';
import AfterPay from './afterpay';
import Album from './album';
import Alert from './alert';
import Amex from './amex';
import Arrow from './arrow';
import ArrowDown from './arrowDown';
import ArrowLeft from './arrowLeft';
import ArrowRight from './arrowRight';
import ArrowWithTail from './arrowWithTail';
import Bag from './bag';
import BagAlt from './bagAlt';
import BagPlus from './bagPlus';
import Bin from './bin';
import Burger from './burger';
import Caret from './caret';
import CaretDown from './caretDown';
import CaretDownMps from './caretDownMps';
import Cart from './cart';
import CategoryDogs from './categoryDogs';
import CategoryCats from './categoryCats';
import CategoryHorses from './categoryHorses';
import CategoryBirds from './categoryBirds';
import CartAdd from './cartAdd';
import Check from './check';
import CheckAlt from './checkAlt';
import CheckFilled from './checkFilled';
import CheckOutline from './checkOutline';
import Click from './click';
import Close from './close';
import CreditCard from './creditCard';
import Cross from './cross';
import Currency from './currency';
import Cycle from './cycle';
import Delivery from './delivery';
import Edit from './edit';
import Equaliser from './equaliser';
import Facebook from './facebook';
import FacebookAlt from './facebookAlt';
import FacebookInverse from './facebookInverse';
import FileDoc from './fileDoc';
import FileImg from './fileImg';
import FileMp3 from './fileMp3';
import FileMp4 from './fileMp4';
import FileOther from './fileOther';
import FilePdf from './filePdf';
import FilePpt from './filePpt';
import FileXls from './fileXls';
import FileZip from './fileZip';
import Filter from './filter';
import FilterAlt from './filterAlt';
import GiftBox from './gift-box';
import Hamburger from './hamburger';
import Heart from './heart';
import HeartAlt from './heartAlt';
import HeartFill from './heartFill';
import Headset from './headset';
import HelpCircle from './help-circle';
import House from './house';
import Instagram from './instagram';
import InstagramAlt from './instagramAlt';
import Klarna from './klarna';
import KlarnaMin from './klarna-min';
import Link from './link';
import Linkedin from './linkedin';
import List from './list';
import Logout from './logout';
import Paypal from './paypal';
import PaypalMin from './paypal-min';
import PaypalColor from './paypal-color';
import MapMarker from './map-marker';
import MasterCard from './master-card';
import Minus from './minus';
import MinusAlt from './minusAlt';
import PaymentAdd from './paymentAdd';
import PaymentCheckout from './paymentCheckout';
import PaymentRepay from './paymentRepay';
import Phone from './phone';
import PhoneAlt from './phoneAlt';
import Pinterest from './pinterest';
import PinterestInverse from './pinterestInverse';
import Play from './play';
import Plus from './plus';
import Purse from './purse';
import Question from './question';
import QuickView from './quickView';
import Search from './search';
import SearchAlt from './searchAlt';
import Star from './star';
import StarBlack from './star-black';
import StoreLocator from './store-locator';
import Swatch from './swatch';
import Tick from './tick';
import Translate from './translate';
import Truck from './truck';
import TruckMoving from './truckMoving';
import Twitter from './twitter';
import TwitterAlt from './twitterAlt';
import TwitterInverse from './twitterInverse';
import User from './user';
import UserAlt from './userAlt';
import View from './view';
import Visa from './visa';
import WhiteBag from './whiteBag';
import Youtube from './youtube';
import YoutubeAlt from './youtubeAlt';
import ZipLogo from './zip-logo';
import ZipMin from './zip-min';
import ZipMoneyLogo from './zip-money-logo';
import ZipPayLogo from './zip-pay-logo';
import Kangaroo from './kangaroo';
import Box from './box';
import Drug from './drugs';
import Pet from './petchem';
import Cat from './cat';
import BlockStar from './block-star';
import GhostStar from './ghost-star';
import Autoship from './autoship';
import ChevDown from './chevDown';
import ChevronRight from './chevron-right';
import ChevronRightMps from './chevron-right-mps';
import ChevronLeft from './chevron-left';
import Home from './home';
import Trash from './trash';
import TrashMpsIcon from './trash-mps';
import TrashAlt from './trash-alt';
import Pencil from './pencil';
import PencilMpsIcon from './pencil-mps';
import Prescription from './prescription';
import ReviewStar from './review-star';
import Envelope from './envelope';
import EnvelopeMps from './envelope-mps';
import Rx from './rx';
import RxMps from './rx-mps';
import Paw from './paw';
import Lock from './lock';
import BoxAlt from './box-alt';
import FacetPlus from './facet-plus';
import FacetMinus from './facet-minus';
import FacetEmpty from './facet-empty';
import FacetSelected from './facet-selected';
import FacetAdjust from './facet-adjust';
import Rotate from './rotate';
import SmallBox from './small-box';
import Contact from './contact';
import Cold from './cold';
import PlusAlt from './plus-alt';
import PlusMpsAlt from './plus-mps-alt';
import CartPlus from './cart-plus';
import External from './external-link';
import ExternalMps from './external-link-mps';
import PrescriptionWarningIcon from './prescription-warning';
import ShippingBoxIcon from './shippingBox';

function Icon({ symbol }) {
  switch (symbol) {
    case 'external-link':
      return <External />;
    case 'external-link-mps':
      return <ExternalMps />;
    case 'cart-plus':
      return <CartPlus />;
    case 'cold':
      return <Cold />;
    case 'small-box':
      return <SmallBox />;
    case 'contact':
      return <Contact />;
    case 'rotate':
      return <Rotate />;
    case 'facet-adjust':
      return <FacetAdjust />;
    case 'facet-plus':
      return <FacetPlus />;
    case 'facet-minus':
      return <FacetMinus />;
    case 'facet-empty':
      return <FacetEmpty />;
    case 'facet-selected':
      return <FacetSelected />;
    case 'lock':
      return <Lock />;
    case 'paw':
      return <Paw />;
    case 'review-star':
      return <ReviewStar />;
    case 'prescription':
      return <Prescription />;
    case 'prescriptionWarning':
      return <PrescriptionWarningIcon />;
    case 'trash-alt':
      return <TrashAlt />;
    case 'trash':
      return <Trash />;
    case 'trash-mps':
      return <TrashMpsIcon />;
    case 'pencil':
      return <Pencil />;
    case 'pencil-mps':
      return <PencilMpsIcon />;
    case 'home':
      return <Home />;
    case 'chevDown':
      return <ChevDown />;
    case 'chevRight':
      return <ChevronRight />;
    case 'chevRightMps':
      return <ChevronRightMps />;
    case 'chevLeft':
      return <ChevronLeft />;
    case 'add':
      return <Add />;
    case 'auto-ship':
      return <Autoship />;
    case 'star-fill':
      return <BlockStar />;
    case 'star-outline':
      return <GhostStar />;
    case 'cat':
      return <Cat />;
    case 'addReview':
      return <AddReview />;
    case 'afterpayArrows':
      return <AfterPayArrows />;
    case 'afterPayLogo':
      return <AfterPayLogo />;
    case 'afterPay':
      return <AfterPay />;
    case 'album':
      return <Album />;
    case 'alert':
      return <Alert />;
    case 'amex':
      return <Amex />;
    case 'arrow':
      return <Arrow />;
    case 'arrowDown':
      return <ArrowDown />;
    case 'arrowLeft':
      return <ArrowLeft />;
    case 'arrowRight':
      return <ArrowRight />;
    case 'arrowWithTail':
      return <ArrowWithTail />;
    case 'bag':
      return <Bag />;
    case 'bagAlt':
      return <BagAlt />;
    case 'bagPlus':
      return <BagPlus />;
    case 'bin':
      return <Bin />;
    case 'burger':
      return <Burger />;
    case 'caret':
      return <Caret />;
    case 'caretDown':
      return <CaretDown />;
    case 'caretDownMps':
      return <CaretDownMps />;
    case 'cart':
      return <Cart />;
    case 'categoryDogs':
      return <CategoryDogs />;
    case 'categoryCats':
      return <CategoryCats />;
    case 'categoryBirds':
      return <CategoryBirds />;
    case 'categoryHorses':
      return <CategoryHorses />;
    case 'cartAdd':
      return <CartAdd />;
    case 'check':
      return <Check />;
    case 'checkAlt':
      return <CheckAlt />;
    case 'checkFilled':
      return <CheckFilled />;
    case 'checkOutline':
      return <CheckOutline />;
    case 'click':
      return <Click />;
    case 'close':
      return <Close />;
    case 'creditcard':
      return <CreditCard />;
    case 'cross':
      return <Cross />;
    case 'currency':
      return <Currency />;
    case 'cycle':
      return <Cycle />;
    case 'delivery':
      return <Delivery />;
    case 'edit':
      return <Edit />;
    case 'equaliser':
      return <Equaliser />;
    case 'facebook':
      return <Facebook />;
    case 'facebookAlt':
      return <FacebookAlt />;
    case 'facebookInverse':
      return <FacebookInverse />;
    case 'fileDoc':
      return <FileDoc />;
    case 'fileImg':
      return <FileImg />;
    case 'fileMp3':
      return <FileMp3 />;
    case 'fileMp4':
      return <FileMp4 />;
    case 'fileOther':
      return <FileOther />;
    case 'filePdf':
      return <FilePdf />;
    case 'filePpt':
      return <FilePpt />;
    case 'fileXls':
      return <FileXls />;
    case 'fileZip':
      return <FileZip />;
    case 'filter':
      return <Filter />;
    case 'filterAlt':
      return <FilterAlt />;
    case 'giftbox':
      return <GiftBox />;
    case 'hamburger':
      return <Hamburger />;
    case 'heart':
      return <Heart />;
    case 'heartAlt':
      return <HeartAlt />;
    case 'heartFill':
      return <HeartFill />;
    case 'headset':
      return <Headset />;
    case 'helpCircle':
      return <HelpCircle />;
    case 'house':
      return <House />;
    case 'instagram':
      return <Instagram />;
    case 'instagramAlt':
      return <InstagramAlt />;
    case 'klarna':
      return <Klarna />;
    case 'klarna-min':
      return <KlarnaMin />;
    case 'link':
      return <Link />;
    case 'linkedin':
      return <Linkedin />;
    case 'list':
      return <List />;
    case 'logout':
      return <Logout />;
    case 'paypal':
      return <Paypal />;
    case 'paypal-min':
      return <PaypalMin />;
    case 'paypal-color':
      return <PaypalColor />;
    case 'mapMarker':
      return <MapMarker />;
    case 'masterCard':
      return <MasterCard />;
    case 'minus':
      return <Minus />;
    case 'minusAlt':
      return <MinusAlt />;
    case 'paymentAdd':
      return <PaymentAdd />;
    case 'paymentCheckout':
      return <PaymentCheckout />;
    case 'paymentRepay':
      return <PaymentRepay />;
    case 'phone':
      return <Phone />;
    case 'phoneAlt':
      return <PhoneAlt />;
    case 'pinterest':
      return <Pinterest />;
    case 'pinterestInverse':
      return <PinterestInverse />;
    case 'play':
      return <Play />;
    case 'plus':
      return <Plus />;
    case 'plus-alt':
      return <PlusAlt />;
    case 'plus-mps-alt':
      return <PlusMpsAlt />;
    case 'purse':
      return <Purse />;
    case 'question':
      return <Question />;
    case 'quickView':
      return <QuickView />;
    case 'search':
      return <Search />;
    case 'searchAlt':
      return <SearchAlt />;
    case 'star':
      return <Star />;
    case 'starBlack':
      return <StarBlack />;
    case 'storeLocator':
      return <StoreLocator />;
    case 'swatch':
      return <Swatch />;
    case 'tick':
      return <Tick />;
    case 'translate':
      return <Translate />;
    case 'truck':
      return <Truck />;
    case 'truckMoving':
      return <TruckMoving />;
    case 'twitter':
      return <Twitter />;
    case 'twitterAlt':
      return <TwitterAlt />;
    case 'twitterInverse':
      return <TwitterInverse />;
    case 'user':
      return <User />;
    case 'userAlt':
      return <UserAlt />;
    case 'view':
      return <View />;
    case 'visa':
      return <Visa />;
    case 'whiteBag':
      return <WhiteBag />;
    case 'youtube':
      return <Youtube />;
    case 'youtubeAlt':
      return <YoutubeAlt />;
    case 'zipLogo':
      return <ZipLogo />;
    case 'zip-min':
      return <ZipMin />;
    case 'zipMoneyLogo':
      return <ZipMoneyLogo />;
    case 'zipPayLogo':
      return <ZipPayLogo />;
    case 'kangaroo':
      return <Kangaroo />;
    case 'box':
      return <Box />;
    case 'boxAlt':
      return <BoxAlt />;
    case 'drugs':
      return <Drug />;
    case 'pet':
      return <Pet />;
    case 'envelope':
      return <Envelope />;
    case 'envelope-mps':
      return <EnvelopeMps />;
    case 'rx':
      return <Rx />;
    case 'rx-mps':
      return <RxMps />;
    case 'shipping-box':
      return <ShippingBoxIcon />;
    default:
      return <span>Unknown icon: {symbol}</span>;
  }
}

export default Icon;
